// feature fleet-profile
export { referenceSettings } from './reference';
export { fleetServiceIssueSettings } from './service-issue';
export { equipmentServiceSettings } from './equipment-service';
export { compensationGroupSettings } from './compensation-group';
export { contactSettings, vendorContactSettings } from './contacts';
export { truckLocationSettings, trailerLocationSettings } from './location';
export { truckOwnershipSettings, trailerOwnershipSettings } from './ownership';
export { truckInsuranceSettings, trailerInsuranceSettings } from './insurance';
export { compensationSettings, vendorCompensationSettings } from './compensation';
export { payToLocationSettings, vendorPayToLocationsSettings } from './pay-to-location';
export { truckSpecificationSettings, trailerSpecificationSettings } from './specification';
export { payrollAccessorialSettings, vendorPayrollAccessorialSettings } from './payroll-accessorial';
export { integrationSettings, truckIntegrationOptions, trailerIntegrationOptions } from './integration';
export { truckEquipmentComponentSettings, trailerEquipmentComponentSettings } from './equipment-component';
export { monthlyPayrollDeductionSettings, vendorMonthlyPayrollDeductionSettings } from './monthly-payroll-deduction';
export { documentSettings, truckDocumentSettings, vendorDocumentSettings, trailerDocumentSettings } from './documents';
export {
  lastKnownLocationSettings,
  truckLastKnownLocationSettings,
  trailerLastKnownLocationSettings,
} from './last-known-location';
export {
  truckAssignmentHistorySettings,
  driverAssignmentHistorySettings,
  vendorAssignmentHistorySettings,
  trailerAssignmentHistorySettings,
} from './assignment-history';
export {
  accessorialSettings,
  vendorAccessorialSettings,
  sharedAccessorialSettings,
  vendorSharedAccessorialSettings,
  vendorCompensationAccessorialSettings,
} from './accessorial';
//////////////////////////////////////////////////
